import { useQuery } from '@tanstack/react-query';
import { get } from '../api/client.js';

// Polls the live feed every 10s. `since` snaps to "the last 24 hours"
// at hook mount; client can override via the optional arg.
export function useLiveFeed({ since, limit = 50 } = {}) {
  const sinceMs = since || Date.now() - 24 * 3_600_000;
  return useQuery({
    queryKey: ['live-feed', sinceMs, limit],
    queryFn: async () => {
      const body = await get(`/api/admin/live-feed?since=${sinceMs}&limit=${limit}`);
      return body;
    },
    staleTime: 5_000,
    refetchInterval: 10_000,
    refetchOnWindowFocus: true,
  });
}
